module.exports = __webpack_public_path__ + "static/media/SF-2.78bd47d9.mp3";